var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 160 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n\n      .st2 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    y: 0,
    width: 160,
    height: 36.3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9,35h6.1v-13.6L24,.4h-6.5l-5,13.8h-.9L6.8.4H0l9,21v13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.1,35.4h19.4v-4.8h-13.3v-10.8h12v-4.8h-12V5.5h12.8V.7h-18.8v34.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.4,25.6v.9c0,3.2.8,5.6,2.5,7.3,1.7,1.7,4.5,2.5,8.5,2.5s6.8-.8,8.9-2.5c2.1-1.6,3.1-4.3,3.1-7.9s0-2-.3-2.9c-.2-.8-.5-1.6-1-2.3-.5-.7-1.1-1.4-2-2-.9-.6-2-1.3-3.3-1.8l-5.6-2.4c-1.7-.7-2.8-1.5-3.3-2.3-.5-.8-.8-1.8-.8-3.1s0-1.2.2-1.7c.2-.6.4-1.1.8-1.6.4-.4.9-.8,1.5-1.1.6-.3,1.3-.4,2.2-.4,1.6,0,2.8.6,3.5,1.6.6.9.9,2.2,1,3.7h5.8v-.4c0-1.7-.2-3-.8-4.2-.5-1.1-1.2-2.1-2.2-2.8-.9-.8-2.1-1.3-3.3-1.6-1.4-.3-2.8-.5-4.3-.5-3.3,0-5.9.8-7.8,2.5-1.8,1.6-2.8,4.2-2.8,7.6s.2,2.7.5,3.8c.3,1,.9,1.9,1.6,2.8.8.8,1.7,1.5,2.8,2.1,1.2.7,2.6,1.2,4.1,1.7,1.4.5,2.3.9,3.1,1.2.9.4,1.6.9,2.2,1.4.6.5,1,1.1,1.2,1.8.2.7.4,1.5.4,2.3,0,1.7-.5,3-1.5,3.8-1,.8-2.1,1.2-3.4,1.2s-1.9-.2-2.6-.5c-.8-.4-1.3-.8-1.7-1.3-.4-.5-.7-1.2-.9-2-.1-.7-.2-1.5-.2-2.4v-.5h-6.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.1,35.2h20.6v-4.8h-14l13.8-25.1V.6h-19.5v4.8h12.7l-13.6,25.3v4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.4,35h19.4v-4.8h-13.3v-10.8h12v-4.8h-12V5.2h12.8V.4h-18.9v34.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.6,35h19.4v-4.7h-13.3v-10.8h12v-4.8h-12V5.2h12.8V.4h-18.8v34.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.3,11.5c-3,0-5.4,2.4-5.4,5.4s2.4,5.4,5.4,5.4,5.4-2.4,5.4-5.4-2.4-5.4-5.4-5.4ZM83.3,19c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f1fc5441ef6730750baa2ba67b835071.svg";
export { ForwardRef as ReactComponent };